module.exports = __webpack_public_path__ + "media/components/homepage/shared/webinar/static/webinar_speaker_bg-c8e813f55fe364c177b7efbad54b2be7.png";